import cfg from './env-uat';

export default cfg;
